import { render, staticRenderFns } from "./NotificationSummaryPayment.vue?vue&type=template&id=6cf97a68"
import script from "./NotificationSummaryPayment.vue?vue&type=script&lang=js"
export * from "./NotificationSummaryPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports